import React from 'react'

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { number, bool, string } from 'prop-types'

import BatchUploader from './BatchUploader/BatchUploader'
// eslint-disable-next-line import/no-named-as-default
import Listing from './Listing/Listing'
import Publisher from './Publisher'
import TutorialUploader from './TutorialUploader/TutorialUploader'

class Products extends React.Component {
  componentDidMount() {
    const staticPlaceholder = document.getElementsByClassName('js-react-loader')[0]

    if (staticPlaceholder && staticPlaceholder.parentNode) {
      staticPlaceholder.parentNode.removeChild(staticPlaceholder)
    }
  }

  componentDidCatch(error, errorInfo) {
    window.Sentry.captureException(error, { extra: errorInfo })
    // eslint-disable-next-line no-alert
    window.alert(`You are not supposed to see this, please contact our support.\n${errorInfo.componentStack}`)
  }

  render() {
    const {
      participatesInMqs,
      userId,
      cgtStandardEnabled,
      cgtStandardFiltersEnabled,
      userSegment,
      isDownloadMyModelsEnabled,
      isSalesBoostEnabled,
      salesBoostPoints,
      newRoyaltyUi,
      newPublisherView,
      useFullPageView,
      limitTagCampaignsAndCostInflation,
      isSubscriptionColumnEnabled,
      showUseCasesFor3dModels,
      sellerSuspensionAppealsEnabled,
    } = this.props

    return (
      <Router>
        <div
          className={classnames('products-layout', useFullPageView && 'products-layout--fullscreen expanding-content')}
        >
          <Routes>
            <Route
              path="/profile/upload/model"
              element={(
                <Publisher
                  participatesInMqs={participatesInMqs}
                  newRoyaltyUi={newRoyaltyUi}
                  newPublisherView={newPublisherView}
                  showUseCasesFor3dModels={showUseCasesFor3dModels}
                />
              )}
            />
            <Route path="/profile/upload/batch" element={<BatchUploader />} />
            <Route path="/profile/upload/tutorial" element={<TutorialUploader />} />
            <Route
              path="/profile/models"
              element={(
                <Listing
                  userId={userId}
                  cgtStandardEnabled={cgtStandardEnabled}
                  cgtStandardFiltersEnabled={cgtStandardFiltersEnabled}
                  userSegment={userSegment}
                  isDownloadMyModelsEnabled={isDownloadMyModelsEnabled}
                  isSalesBoostEnabled={isSalesBoostEnabled}
                  salesBoostPoints={salesBoostPoints}
                  newRoyaltyUi={newRoyaltyUi}
                  limitTagCampaignsAndCostInflation={limitTagCampaignsAndCostInflation}
                  isSubscriptionColumnEnabled={isSubscriptionColumnEnabled}
                  sellerSuspensionAppealsEnabled={sellerSuspensionAppealsEnabled}
                />
              )}
            />
            <Route
              path="/profile/models/:id/edit"
              element={(
                <Publisher
                  isEditingMode
                  participatesInMqs={participatesInMqs}
                  newRoyaltyUi={newRoyaltyUi}
                  newPublisherView={newPublisherView}
                  showUseCasesFor3dModels={showUseCasesFor3dModels}
                />
              )}
            />
          </Routes>
        </div>
      </Router>
    )
  }
}

Products.propTypes = {
  userId: number.isRequired,
  participatesInMqs: bool.isRequired,
  userSegment: string.isRequired,
  isDownloadMyModelsEnabled: bool,
  isSalesBoostEnabled: bool,
  newRoyaltyUi: bool,
  newPublisherView: bool,
  useFullPageView: bool,
  cgtStandardEnabled: bool,
  cgtStandardFiltersEnabled: bool,
  salesBoostPoints: number,
  limitTagCampaignsAndCostInflation: bool,
  isSubscriptionColumnEnabled: bool,
  showUseCasesFor3dModels: bool,
  sellerSuspensionAppealsEnabled: bool,
}

Products.defaultProps = {
  isDownloadMyModelsEnabled: false,
  isSalesBoostEnabled: false,
  newRoyaltyUi: false,
  newPublisherView: false,
  useFullPageView: false,
  cgtStandardEnabled: false,
  cgtStandardFiltersEnabled: false,
  salesBoostPoints: 0,
  limitTagCampaignsAndCostInflation: false,
  isSubscriptionColumnEnabled: false,
  showUseCasesFor3dModels: false,
  sellerSuspensionAppealsEnabled: false,
}

export default Products
